import React, { useState } from "react";
import "../styles/SalesFunnel.css";

const Portfolio = () => {
  const [active, setActive] = useState("All");

  const portfolioxData = [
    { name: "Healthcare" },
    { name: "Education"},
    { name: "Real Estate" },
    { name: "E-Commerce" },

    { name: "Hospitality" },
    { name: "Technology" },
    { name: "Manufacturing" },
    { name: "Digital Agencies"},

   
  ];

  return (
    <section className="portfolio-sectionx">
      <div className="portfolio-containerx">
        <h2 className="portfolio-headingx">Industries We Serve</h2>

        <div className="portfolio-tabsx">
          {portfolioxData.map((item, index) => (
            <button
              key={index}
              className={`portfolio-btnx ${
                active === item.name ? "active" : ""
              }`}
              onClick={() => setActive(item.name)}
            >
              <span className="portfolio-iconx">{item.icon}</span>
              {item.name}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Portfolio;